<tt-page>
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-button ttText="mietables_update" (ttClick)="updateChanges()" [ttSpin]="updating" ttIcon="fas fa-sync"></tt-button>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
